import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ddtgdhehxhgarkonvpfq.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRkdGdkaGVoeGhnYXJrb252cGZxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ2Njg4MTIsImV4cCI6MjA1MDI0NDgxMn0.mY8nx-lKrNXjJxHU7eEja3-fTSELQotOP4aZbxvmNPY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Add this helper function to check auth state
export const checkUser = async () => {
    try {
        const { data: { session }, error } = await supabase.auth.getSession();
        if (error) throw error;
        
        if (session?.user) {
            localStorage.setItem('user', JSON.stringify(session.user));
            return session.user;
        }
        return null;
    } catch (error) {
        console.error('Error checking user:', error.message);
        return null;
    }
};

export const restoreUserFromLocalStorage = () => {
    const userJson = localStorage.getItem('user');
    if (userJson) {
        return JSON.parse(userJson);
    }
    return null;
};

export default supabase;
